// import { jsonp, ajax } from 'ThreeTerminal_base/base';
import jsonp from '@ifeng/three_terminal/es/base/base/jsonp';

const md5 = require('@ifeng/md5');

const createJsonpCallbackName = (str, num) => {
    num = num ? num : 0;
    let jsonpCallbackName = `_${md5(`${str}_${num}`)}`;

    while (window[jsonpCallbackName]) {
        num++;
        jsonpCallbackName = `_${md5(`${str}_${num}`)}`;
    }

    return jsonpCallbackName;
};

// 获取中国城市对应表
export const getCityMap = async () => {
    const data = await jsonp(
        'https://shankapi.ifeng.com/feedflow/coopdoc/yiqing_local_policy_citymap_new/info/getCityMap',
        {
            jsonpCallback: 'getCityMap',
            cache: false,
        },
    );

    if (data.code === 0) {
        const citymap = data.data.citymap;
        const area = Object.keys(citymap).map(item => ({
            value: item,
            label: item,
            children: Object.keys(citymap[item].citylist).map(child => ({
                value: citymap[item].citylist[child].code,
                label: child,
            })),
        }));

        return [...area];
    }

    return [];
};

// 获取新的隔离政策
export const getPolicyNew = async code => {
    const data = await jsonp(
        `https://shankapi.ifeng.com/feedflow/coopdoc/yiqing_local_policy_2022spring_${code}/info/getPolicy_${code}`,
        {
            jsonpCallback: `getPolicy_${code}`,
            cache: false,
        },
    );

    if (data.code === 0 && data.data) {
        const item = data.data;

        return {
            ...item,
            updateTime: item.update_time.split(' ')[0],
        };
    }

    return {};
};
